import { render } from "./HealthQuickActions.vue?vue&type=template&id=85a269ec&scoped=true"
import script from "./HealthQuickActions.vue?vue&type=script&lang=js"
export * from "./HealthQuickActions.vue?vue&type=script&lang=js"

import "./HealthQuickActions.vue?vue&type=style&index=0&id=85a269ec&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85a269ec"]])

export default __exports__